var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClickandpledgeLogo = function SvgClickandpledgeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "c&p-settings",
    transform: "translate(-210 -634)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 60",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(210 634)",
    fill: "#f05423"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "c&p-logo-icon",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1162",
    d: "M230.289 663.042a5.472 5.472 0 0 1-3.266 1.423 3.884 3.884 0 0 1-3.728-3.728 2.86 2.86 0 0 1 .75-1.873 10.862 10.862 0 0 1 1.6-1.411l-2.073-2.491-.3.2a6.694 6.694 0 0 0-3.272 5.661 6.336 6.336 0 0 0 2.065 4.8 7.335 7.335 0 0 0 5.135 1.939 8.206 8.206 0 0 0 5.181-2.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1163",
    d: "m238.081 664.464-4.628-5.637-3.614-4.37a14.251 14.251 0 0 0 2.989-2.857 4.756 4.756 0 0 0-.7-6.2 5.507 5.507 0 0 0-3.878-1.4 5.505 5.505 0 0 0-3.95 1.447c-.2.18-3.59 3.074-3.59 3.074l2.329 2.857 10.635 12.954.012-.012 2.269 2.785 2.515-2.173Zm-8.759-13.585c-.312.27-.714.588-1.195.948l-.282.2a1.141 1.141 0 0 1-.174-.222l-.857-1.022c-.528-.648-1.021-1.351-1.585-1.993a7.475 7.475 0 0 1 1.423-1.381 2.23 2.23 0 0 1 1.561-.576 2.292 2.292 0 0 1 1.621.558 1.9 1.9 0 0 1 .606 1.459 2.057 2.057 0 0 1-.444 1.339 4.083 4.083 0 0 1-.672.69"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1164",
    d: "m243.998 653.959-7.7 1.4 2.1 1.453-2.7 2.191 1.147 1.356 2.587-2.257.726 2.281Z"
  })))));
};
export default SvgClickandpledgeLogo;